import { useTranslation } from "react-i18next";
import routes from "../../../engine/routes";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { theme, Typography } from "antd";
import { AddressesList } from "../../../shared/container/Addresses/AddressesList/AddressesList";

export const PrincipalAddresses = () => {
  const { t } = useTranslation();

  // Accessing `principal`, `loading`, `id`, and `colorPrimary` as before
  const { principal, loading } = useSelector(state => state.principal);
  const { id } = useParams();
  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.principals(id).addresses.title}
      </Typography.Title>
      {principal._id !== undefined ? (
        <AddressesList principal={principal} type={"postal"} />
      ) : (
        <Typography.Text>
          {t("PrincipalAddresses.noAddressesAvailable")}
        </Typography.Text>
      )}
    </>
  );
};
